export default __webpack_public_path__ + "static/media/innovation-metrics.7b501737.pdf";